// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1HWLb","fileBtn":"File_fileBtn__2oYL6","closeBtn":"File_closeBtn__rV_7I","fileSelected":"File_fileSelected__2fbKO","disabled":"File_disabled__ACMzu"};